import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Layout from "../../components/global/layout";
import { RxCross2 } from "react-icons/rx";
import { FaFile } from "react-icons/fa";
import { toast } from "react-toastify";
import swal from "sweetalert";
import moment from "moment";
import FormControl from "../../components/common/FormControl";
import methodModel from "../../methods/methods";

function stripHtmlTags(html) {
  if (!html) return "";
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
}
export default function EditQuote() {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const { requestQuoteId } = useParams();
  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);
  const [productsDb, setProductsDb] = useState([]);
  const [allTax, setallTax] = useState([]);
  const detailRef = useRef(null);
  const customersRef = useRef([]);
  const productsRef = useRef([]);
  const productsRefDatabase = useRef([]);

  const TAX_RATE_DEFAULT = 6;

  const generateEstimateNo = () => {
    const prefix = "EST";
    const date = new Date().toISOString().slice(0, 10).replace(/-/g, "");
    const random = Math.floor(1000 + Math.random() * 9000);
    return `${prefix}-${date}-${random}`;
  };

  const generateTrackingNo = () => {
    const prefix = "TRK";
    const timestamp = Date.now();
    return `${prefix}-${timestamp}`;
  };

  const [formData, setFormData] = useState({
    CustomerRef: "",
    BillEmail: "",
    BillAddr: "",
    ShipAddr: "",
    billingAddress: {
      bill_line1: "",
      bill_line2: "",
      bill_city: "",
      bill_country: "",
      bill_postal_code: "",
    },
    shippingAddress: {
      ship_line1: "",
      ship_line2: "",
      ship_city: "",
      ship_country: "",
      ship_postal_code: "",
    },
    ShipVia: "",
    ShipDate: "",
    TrackingNum: generateTrackingNo() || "",
    DocNumber: generateEstimateNo() || "",
    TxnDate: new Date().toISOString().split("T")[0],
    ExpirationDate: "",
    estimate_date: "",
    AcceptedBy: "",
    AcceptedDate: "",
    store_name: "",
    po_number: "",
    vendor_details: "",
    store_id: "",
    Line: [
      {
        DetailType: "SalesItemLineDetail",
        SalesItemLineDetail: {
          ItemRef: { value: "", name: "" },
          UnitPrice: 0,
          Qty: 1,
        },
        Description: "",
        Amount: 0,
        item_name: "",
        db_product_id: "",
      },
    ],
    tax_type: "automatic",
    tax_rate_id: "",
    // ── Tax identifiers (NEW, ported from GenerateQuote) ──────────────────
    tax_code_id: "", // rate's own id (used as the dropdown value/key)
    tax_rate_ref: "", // parent tax code id (for TaxRateRef)
    tax_code: "TAX", // "TAX" or "NON", derived from percentage
    apply_tax_after_discount: false,
    // ────────────────────────────────────────────────────────────────────────
    tax_percent: "",
    total_tax: 0,
    discount_value: 0,
    discount_type: "fixed",
    deposit_percent: 0,
    estimateType: "full",
    partialMode: "fixed",
    partialValue: 0,
    CustomerMemo: "",
    PrivateNote: "",
    file: "",
    TotalAmt: 0,
    total_shipping: 0,
  });

  console.log(formData, "formData");

  const parsePrivateNote = (note) => {
    if (!note) return {};

    const getValue = (label) => {
      const regex = new RegExp(`${label}:\\s*(.*)`);
      const match = note.match(regex);
      return match ? match[1].trim() : "";
    };

    return {
      memo: getValue("Memo"),
      vendor_details: getValue("Vendor"),
      store_name: getValue("StoreName"),
      tracking_num: getValue("TrackingNum"),
    };
  };

  const tryAutofill = (custList, prodDbList, detail) => {
    if (!detail) return;

    let matchedCustomer = null;
    if (detail.email) {
      matchedCustomer = custList.find(
        (c) =>
          c.PrimaryEmailAddr?.Address?.toLowerCase() ===
          detail.email.toLowerCase(),
      );
    }

    const bill = detail.billingAddress || {};
    const ship = detail.shippingAddress || {};

    const billText = [
      bill.bill_line1,
      bill.bill_line2,
      bill.bill_city,
      bill.bill_country,
      bill.bill_postal_code,
    ]
      .filter(Boolean)
      .join(", ");

    const shipText = [
      ship.ship_line1,
      ship.ship_line2,
      ship.ship_city,
      ship.ship_country,
      ship.ship_postal_code,
    ]
      .filter(Boolean)
      .join(", ");

    const mappedLines = (detail.line_items || []).map((item) => {
      let matchedDbProd = null;
      let matchedProd = null;

      if (item?.item_name) {
        matchedProd = products.find(
          (p) =>
            p.Name?.toLowerCase().trim() ===
            item.item_name?.toLowerCase().trim(),
        );
      }
      if (item.item_id) {
        matchedDbProd = prodDbList.find(
          (p) => p.Id === item.item_id || p._id === item.item_id,
        );
      }

      if (!matchedDbProd && item.item_name) {
        matchedDbProd = prodDbList.find(
          (p) => p.productName?.toLowerCase() === item.item_name?.toLowerCase(),
        );
      }

      const matchedProductLine = (detail.product_line_items || []).find(
        (pli) =>
          pli?.SalesItemLineDetail?.ItemRef?.value ===
            item?.SalesItemLineDetail?.ItemRef?.value ||
          pli?.db_product_id === item?.db_product_id ||
          pli?.Description === stripHtmlTags(item?.Description),
      );

      const qty = item.qty || 1;

      const dbUnitPrice = Number(
        matchedDbProd?.price ||
          matchedDbProd?.unitPrice ||
          matchedDbProd?.UnitPrice ||
          item.rate ||
          0,
      );

      const dbDescription =
        matchedDbProd?.description ||
        matchedDbProd?.Description ||
        item.description ||
        "";

      return {
        DetailType: "SalesItemLineDetail",
        SalesItemLineDetail: {
          ItemRef: {
            value:
              matchedProd?.Id ||
              item?.SalesItemLineDetail?.ItemRef?.value ||
              "",
            name: "",
          },
          UnitPrice: dbUnitPrice,
          Qty: qty,
        },
        Description: stripHtmlTags(dbDescription),
        Amount: dbUnitPrice * qty,
        item_name: matchedDbProd?.productName || item.item_name || "",

        db_product_id:
          matchedProductLine?.db_product_id ||
          matchedDbProd?.Id ||
          matchedDbProd?._id ||
          "",
      };
    });

    const newTotal = mappedLines.reduce((acc, l) => acc + l.Amount, 0);
    const parsedNote = parsePrivateNote(detail.private_note);
    console.log(parsedNote, detail.PrivateNote, "parsedNote");
    setFormData((prev) => ({
      ...prev,
      PrivateNote: parsedNote.memo || "",
      vendor_details: parsedNote.vendor_details || prev.vendor_details,
      store_name: parsedNote.store_name || prev.store_name,
      TrackingNum: parsedNote.tracking_num || prev.TrackingNum,
      ShipDate: parsedNote.ship_date || prev.ShipDate,
      negotiateMessage: detail?.negotiateMessage,
      CustomerRef: matchedCustomer?.Id || "",
      BillEmail:
        detail.email ||
        matchedCustomer?.PrimaryEmailAddr?.Address ||
        prev.BillEmail,
      BillAddr: billText || prev.BillAddr,
      ShipAddr: shipText || prev.ShipAddr,
      billingAddress: {
        bill_line1: bill.bill_line1 || "",
        bill_line2: bill.bill_line2 || "",
        bill_city: bill.bill_city || "",
        bill_country: bill.bill_country || "",
        bill_postal_code: bill.bill_postal_code || "",
      },
      shippingAddress: {
        ship_line1: ship.ship_line1 || "",
        ship_line2: ship.ship_line2 || "",
        ship_city: ship.ship_city || "",
        ship_country: ship.ship_country || "",
        ship_postal_code: ship.ship_postal_code || "",
      },
      DocNumber: detail.estimate_no || prev.DocNumber,
      ExpirationDate:
        moment(detail.expiration_date).format("YYYY-MM-DD") ||
        prev.ExpirationDate,
      TxnDate:
        moment(detail.estimate_date).format("YYYY-MM-DD") || prev.estimate_date,
      tax_type: detail.tax_type || prev.tax_type,
      tax_rate_id: detail.tax_rate_id || prev.tax_rate_id,
      // ── Tax identifiers (NEW) ────────────────────────────────────────────
      tax_code_id: detail.tax_code_id || prev.tax_code_id,
      tax_rate_ref: detail.tax_rate_ref || prev.tax_rate_ref,
      tax_code: detail.tax_code || prev.tax_code,
      apply_tax_after_discount:
        detail.apply_tax_after_discount ?? prev.apply_tax_after_discount,
      // ──────────────────────────────────────────────────────────────────────
      tax_percent: detail.tax_percent ?? prev.tax_percent ?? "0",
      total_tax: detail.total_tax ?? prev.total_tax,
      discount_value: detail.discount_value ?? prev.discount_value,
      discount_type: detail.discount_type || prev.discount_type,
      estimateType: detail.estimateType || prev.estimateType || "full",
      partialMode: detail.partialMode || prev.partialMode || "fixed",
      partialValue: detail.partialValue !== undefined ? detail.partialValue : (prev.partialValue || 0),
      CustomerMemo: detail.customer_memo || prev.CustomerMemo,
      file: detail.file || prev.file,
      // markup_value: detail.markup_value ?? prev.markup_value,
      // markup_type: detail.markup_type || prev.markup_type,
      Line: mappedLines.length ? mappedLines : prev.Line,
      TotalAmt: mappedLines.length ? newTotal : prev.TotalAmt,
    }));
  };

  const fetchInitialData = async () => {
    loader(true);
    try {
      const [custRes, prodRes, proddb] = await Promise.all([
        ApiClient.post("quickbook/customers", {
          quickbook_token: user?.quick_book_accesToken || "",
          company: user?.quick_book_companyId,
        }),
        ApiClient.post("quickbook/items/db", {
          quickbook_token: user?.quick_book_accesToken || "",
          company: user?.quick_book_companyId,
        }),
        ApiClient.get("product/listing", {
          status: "active",
        }),
      ]);

      const custList = custRes?.success ? custRes.data || [] : [];
      const prodList = prodRes?.success
        ? (prodRes?.data || []).map((item) => ({
            ...item,
            Name: item?.name,
            Description: stripHtmlTags(item?.description),
            Id: item?.qbId,
            UnitPrice: item?.unitPrice,
          }))
        : [];
      const prodDbList = proddb?.success ? proddb.data?.products || [] : [];

      customersRef.current = custList;
      productsRef.current = prodList;
      productsRefDatabase.current = prodDbList;

      setCustomers(custList);
      setProducts(prodList);
      setProductsDb(prodDbList);

      if (detailRef.current) {
        tryAutofill(custList, prodDbList, detailRef.current);
      }
    } catch (err) {
      console.error(err);
    }
    loader(false);
  };

  const fetchRequestQuoteDetail = async () => {
    if (!requestQuoteId) return;
    loader(true);
    try {
      const res = await ApiClient.get(
        `generate-quote/detail?id=${requestQuoteId}`,
      );
      if (res?.success && res?.data) {
        detailRef.current = res.data;
        if (
          customersRef.current.length > 0 ||
          productsRefDatabase.current.length > 0
        ) {
          tryAutofill(
            customersRef.current,
            productsRefDatabase.current,
            res.data,
          );
        }
      }
    } catch (err) {
      console.error(err);
      swal({
        icon: "error",
        title: "Error",
        text: "Failed to load request quote details",
        confirmButtonColor: "#115B9D",
      });
    }
    loader(false);
  };

  // ── Tax codes fetch (ported from GenerateQuote) ──────────────────────────
  const getAllTax = () => {
    ApiClient.get("quickbook-tax/tax-codes").then((res) => {
      if (res?.data?.length > 0) {
        const uniqueRates = new Map();

        (res.data || []).forEach((tax) => {
          (tax.rates || []).forEach((rate) => {
            const percentage = Number(rate.percentage);

            if (!uniqueRates.has(percentage)) {
              uniqueRates.set(percentage, {
                tax_rate_ref: tax.id,
                id: rate.id,
                percentage,
                name: `${methodModel.capitalizeFirstLetter(rate?.name)} (${percentage}%)`,
              });
            }
          });
        });

        const sortedRates = Array.from(uniqueRates.values()).sort(
          (a, b) => a.percentage - b.percentage,
        );

        setallTax(sortedRates);
      }
    });
  };

  useEffect(() => {
    fetchInitialData();
    fetchRequestQuoteDetail();
    getAllTax();
  }, []);

  const subtotalbeforemarkup = formData.TotalAmt;
  const markupAmt =
    formData.markup_type === "percentage"
      ? (Number(formData.markup_value) / 100) * subtotalbeforemarkup
      : Number(formData.markup_value) || 0;
  const subtotal = formData.TotalAmt + markupAmt;
  const taxPercent = Number(formData.tax_percent) || 0;
  const taxAmt = (subtotal * taxPercent) / 100;
  const discountAmt =
    formData.discount_type === "percent"
      ? (subtotal * Number(formData.discount_value)) / 100
      : Number(formData.discount_value) || 0;

  const totalShippingAmt = Number(formData.total_shipping) || 0;
  const estimateTotal = subtotal - discountAmt + taxAmt + totalShippingAmt;
  const depositAmt = (estimateTotal * Number(formData.deposit_percent)) / 100;
  const computedPartialAmt =
    formData.estimateType === "partial" && Number(formData.partialValue) > 0
      ? formData.partialMode === "percentage"
        ? (Number(formData.partialValue) / 100) * estimateTotal
        : Number(formData.partialValue)
      : 0;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ── Tax handler (NEW, ported from GenerateQuote) ─────────────────────────
  // allTax entries look like: { tax_rate_ref, id, percentage, name }
  // - id            -> rate's own id (stored as tax_code_id, used as dropdown value/key)
  // - tax_rate_ref  -> parent tax code id (stored as tax_rate_ref, used for TaxRateRef)
  // - percentage    -> stored as tax_percent (drives all amount calculations, unchanged)
  // - tax_code      -> "NON" when percentage is 0, otherwise "TAX"
  const handleTaxChange = (selectedRateId) => {
    const selectedTax = allTax.find((t) => t.id === selectedRateId);
    if (!selectedTax) return;

    setFormData((prev) => ({
      ...prev,
      tax_percent: selectedTax.percentage,
      tax_code_id: selectedTax.id,
      tax_rate_ref: selectedTax.tax_rate_ref,
      tax_code: selectedTax.percentage === 0 ? "NON" : "TAX",
    }));
  };

  const handleLineChange = (index, field, value) => {
    const newLines = [...formData.Line];

    if (field === "db_product_id") {
      const dbProduct = productsDb.find(
        (p) => p.Id === value || p._id === value,
      );

      newLines[index].db_product_id = value;
      newLines[index].item_name = dbProduct?.productName || "";

      if (dbProduct?.qty || dbProduct?.quantity) {
        newLines[index].SalesItemLineDetail.Qty =
          Number(dbProduct?.qty || dbProduct?.quantity) || 1;
      }

      const dbUnitPrice = Number(
        dbProduct?.price || dbProduct?.unitPrice || dbProduct?.UnitPrice || 0,
      );
      const dbDescription =
        dbProduct?.description || dbProduct?.Description || "";

      newLines[index].SalesItemLineDetail.UnitPrice = dbUnitPrice;
      newLines[index].Description = stripHtmlTags(dbDescription);
    } else if (field === "ItemRef") {
      const qbProduct = products.find((p) => p.Id === value);

      if (!qbProduct) {
        const dbProduct = productsDb.find(
          (p) =>
            p.Id === newLines[index].db_product_id ||
            p._id === newLines[index].db_product_id,
        );
        newLines[index].SalesItemLineDetail.ItemRef = { value: "", name: "" };
        newLines[index].SalesItemLineDetail.UnitPrice = Number(
          dbProduct?.price || dbProduct?.unitPrice || dbProduct?.UnitPrice || 0,
        );
        newLines[index].Description =
          stripHtmlTags(dbProduct?.description) ||
          stripHtmlTags(dbProduct?.Description) ||
          "";
      } else {
        newLines[index].SalesItemLineDetail.ItemRef = {
          value: qbProduct.Id,
          name: qbProduct.Name,
        };
        newLines[index].SalesItemLineDetail.UnitPrice =
          qbProduct.UnitPrice || 0;
        newLines[index].Description =
          stripHtmlTags(qbProduct.Description) || "";
      }
    } else if (field === "Qty") {
      newLines[index].SalesItemLineDetail.Qty = Number(value);
    } else if (field === "UnitPrice") {
      newLines[index].SalesItemLineDetail.UnitPrice = Number(value);
    } else {
      newLines[index][field] = value;
    }

    newLines[index].Amount =
      newLines[index].SalesItemLineDetail.Qty *
      newLines[index].SalesItemLineDetail.UnitPrice;

    const total = newLines.reduce((acc, l) => acc + l.Amount, 0);
    setFormData((prev) => ({ ...prev, Line: newLines, TotalAmt: total }));
  };

  const addLine = () => {
    setFormData((prev) => ({
      ...prev,
      Line: [
        ...prev.Line,
        {
          DetailType: "SalesItemLineDetail",
          SalesItemLineDetail: {
            ItemRef: { value: "", name: "" },
            UnitPrice: 0,
            Qty: 1,
          },
          Description: "",
          Amount: 0,
          item_name: "",
          db_product_id: "",
        },
      ],
    }));
  };

  const removeLine = (index) => {
    const newLines = formData.Line.filter((_, i) => i !== index);
    const total = newLines.reduce((acc, l) => acc + l.Amount, 0);
    setFormData((prev) => ({ ...prev, Line: newLines, TotalAmt: total }));
  };

  const showError = (msg) =>
    swal({
      icon: "error",
      title: "Validation Error",
      text: msg,
      confirmButtonColor: "#115B9D",
      confirmButtonText: "OK",
    });

  const validate = () => {
    if (!formData.CustomerRef) {
      showError("Please select a customer");
      return false;
    }
    if (!formData.BillEmail) {
      showError("Customer email is required");
      return false;
    }
    if (!formData.TxnDate) {
      showError("Estimate date is required");
      return false;
    }
    if (formData.Line.length === 0) {
      showError("Please add at least one line item");
      return false;
    }
    for (let i = 0; i < formData.Line.length; i++) {
      const line = formData.Line[i];
      if (!line.SalesItemLineDetail.ItemRef.value && !line?.item_name) {
        showError(`Please select a product for line ${i + 1}`);
        return false;
      }
      if (
        !line.SalesItemLineDetail.UnitPrice ||
        line.SalesItemLineDetail.UnitPrice <= 0
      ) {
        showError(`Please enter a rate greater than 0 for line ${i + 1}`);
        return false;
      }
      if (!line.SalesItemLineDetail.Qty || line.SalesItemLineDetail.Qty <= 0) {
        showError(`Qty must be greater than 0 for line ${i + 1}`);
        return false;
      }
    }
    return true;
  };

  // ── Updated handleSubmit: uses generate-quote/update (PUT) ──
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    loader(true);
    try {
      // Map formData.Line → line_items shape expected by generate-quote/update
      const line_items = formData.Line.map((l) => ({
        item_name: l.SalesItemLineDetail?.ItemRef?.name || l.item_name || "",
        description: stripHtmlTags(l.Description) || "",
        qty: l.SalesItemLineDetail.Qty,
        rate: l.SalesItemLineDetail.UnitPrice,
        // Keep these extra fields — backend ignores unknowns, but nothing breaks
        amount: l.Amount,
        DetailType: "SalesItemLineDetail",
        // NEW — per-line tax code, derived the same way as the header tax code
        TaxCodeRef: { value: formData.tax_code },
      }));
      const product_line_items = formData.Line.map((l) => ({
        item_name: l.SalesItemLineDetail?.ItemRef?.name || l.item_name || "",
        description: stripHtmlTags(l.Description) || "",
        qty: l.SalesItemLineDetail.Qty,
        rate: l.SalesItemLineDetail.UnitPrice,
        // Keep these extra fields — backend ignores unknowns, but nothing breaks
        amount: l.Amount,
        DetailType: "SalesItemLineDetail",
        db_product_id: l?.db_product_id,
        TaxCodeRef: { value: formData.tax_code },
      }));
      const privateNoteFields = [
        ["Memo", formData.PrivateNote],
        ["Accepted By", formData.AcceptedBy],
        ["Accepted Date", formData.AcceptedDate],
        ["Shipping Corp", formData.shipping_corp],
        ["Vendor", formData.vendor_details],
        ["StoreName", formData.store_name],
        ["ShipDate", formData.ShipDate],
        ["TrackingNum", formData.TrackingNum],
      ];

      const PrivateNote = privateNoteFields
        .filter(([_, value]) => value)
        .map(([label, value]) => `${label}: ${value}`)
        .join("\n");
      const payload = {
        status: "estimated",
        id: requestQuoteId,
        line_items,
        product_line_items,
        quickbook_token: user?.quick_book_accesToken || "",
        company: user?.quick_book_companyId,
        CustomerRef: { value: formData?.CustomerRef || null },
        BillEmail: formData.BillEmail,
        BillAddr: {
          Line1: formData.billingAddress?.bill_line1,
          City: formData.billingAddress?.bill_city,
          Country: formData.billingAddress?.bill_country,
          PostalCode: formData.billingAddress?.bill_postal_code,
        },
        ShipAddr: {
          Line1: formData.shippingAddress?.ship_line1,
          City: formData.shippingAddress?.ship_city,
          Country: formData.shippingAddress?.ship_country,
          PostalCode: formData.shippingAddress?.ship_postal_code,
        },
        billingAddress: formData.billingAddress,
        shippingAddress: formData.shippingAddress,
        ShipMethodRef: {
          value: "1",
          name: "Ship via",
        },
        DocNumber: formData.DocNumber,
        TxnDate: formData.TxnDate,
        ExpirationDate: formData.ExpirationDate,
        estimate_date: formData.estimate_date,
        CustomerMemo: { value: formData?.CustomerMemo },
        // NEW — TxnTaxCodeRef now reflects TAX/NON instead of being hardcoded
        TxnTaxDetail: { TxnTaxCodeRef: { value: formData.tax_code } },
        PrivateNote,
        tax_percent: Number(formData.tax_percent),
        total_tax: taxAmt,
        // NEW — tax identifiers sent through to the backend
        tax_code: formData.tax_code,
        tax_rate_ref: formData.tax_rate_ref,
        tax_code_id: formData.tax_code_id,
        apply_tax_after_discount: formData.apply_tax_after_discount ?? false,
        subtotal: subtotal,
        discount_value: Number(formData.discount_value),
        discount_type: formData.discount_type,
        markup_type: formData.markup_type,
        markup_value: 0,
        estimateType: formData.estimateType || "full",
        partialMode: formData.partialMode || "percentage",
        partialValue: Number(formData.partialValue) || 0,
        total_amount: estimateTotal,
      };

      const res = await ApiClient.put("generate-quote/update", payload);

      if (res?.success) {
        loader(false);
        const action = await swal({
          icon: "success",
          title: "Estimate Updated Successfully!",
          text: "Your estimate has been moved to the Pending tab.\n Click the button below to view the estimate details.",
          buttons: {
            list: {
              text: "Go Back",
              value: "list",
            },
            view: {
              text: "View Estimate",
              value: "view",
            },
          },
        });

        if (action === "view") {
          navigate(`/estimate/detail/${res?.data?.id || res?.data?._id}`);
        }

        if (action === "list") {
          navigate(`/order/management?tab=estimate`);
        }
      } else {
        loader(false);
        swal({
          icon: "error",
          title: "Error",
          text: res?.message || "Failed to update estimate",
          confirmButtonColor: "#115B9D",
        });
      }
    } catch (err) {
      console.error("Update error:", err);
      swal({
        icon: "error",
        title: "Error",
        text: "An error occurred while updating the estimate",
        confirmButtonColor: "#115B9D",
      });
      loader(false);
    }
  };

  const extensionsAllow = ["doc", "pdf"];

  const uploadFile = (e) => {
    let files = e.target.files;
    let file = files?.item(0);
    if (!file) return;

    const fileExtension = file?.name?.split(".").pop().toLowerCase();
    let isAllow = extensionsAllow.includes(fileExtension);
    if (!isAllow) {
      toast.error(
        "Please upload a valid file. Accepted formats include document files in DOC and PDF formats.",
      );
      return;
    }

    loader(true);
    ApiClient.postFormFileData("upload/document", { file }).then((res) => {
      if (res.success) {
        setFormData({ ...formData, file: res?.fileName });
      }
      loader(false);
    });
  };

  return (
    <Layout>
      <div className="max-xl:container xl:max-w-[1280px]  mx-auto max-w-6xl py-5">
        <div className="bg-white shadow-lg rounded-2xl border border-gray-100 px-5 sm:px-6 py-6">
          <div className="flex gap-y-2 gap-x-3 flex-wrap justify-between items-center mb-8 border-b pb-4">
            <h1 className="text-xl sm:text-2xl font-bold text-[#115B9D]">
              Edit Estimate
            </h1>
          </div>

          <form onSubmit={handleSubmit} className="space-y-8">
            <div>
              <div className="space-y-4 py-5 border border-l-0 border-t-2 border-r-0 border-b-[#115B9D] border-dashed negotation-message">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                    Negotiation Message
                  </label>
                  <p>{formData?.negotiateMessage || "--"}</p>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
              <div className="md:col-span-1">
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                  Customer
                </label>
                <div className="capitalize ">
                  <FormControl
                    disabled
                    className="capitalize"
                    placeholder="Select Customer"
                    theme="search"
                    type="select"
                    displayValue="DisplayName"
                    options={customers?.map((c) => ({
                      id: c.Id,
                      DisplayName: c.DisplayName,
                    }))}
                    value={formData.CustomerRef}
                    onChange={(e) =>
                      setFormData({ ...formData, CustomerRef: e })
                    }
                  />
                </div>
              </div>

              <div className="md:col-span-1">
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                  Customer Email
                </label>
                <input
                  disabled
                  type="email"
                  name="BillEmail"
                  className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                  value={formData.BillEmail}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
              <div className="space-y-4 bg-gray-50/50 rounded-2xl p-5">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                    Bill to
                  </label>
                  <textarea
                    name="BillAddr"
                    rows="4"
                    className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                    value={formData.BillAddr}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                      Ship via
                    </label>
                    <input
                      type="text"
                      name="ShipVia"
                      className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                      value="Ship via"
                      disabled
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-4 bg-gray-50/50 rounded-2xl p-5">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                    Ship to
                  </label>
                  <textarea
                    name="ShipAddr"
                    rows="4"
                    className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                    value={formData.ShipAddr}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                      Estimate no.
                    </label>
                    <input
                      type="text"
                      name="DocNumber"
                      className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                      value={formData.DocNumber}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                      Estimate date
                    </label>
                    <input
                      type="date"
                      name="TxnDate"
                      className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                      value={formData.TxnDate}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>

              <div className="space-y-4 bg-gray-50/50 rounded-2xl p-5">
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                    Ship from (hidden)
                  </label>
                  <textarea
                    rows="4"
                    readOnly
                    className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none transition-all border-gray-300"
                    value="2000 Avenue P Ste 9&#10;Riviera Beach, FL 33404"
                  />
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                      Tracking no.
                    </label>
                    <input
                      type="text"
                      name="TrackingNum"
                      className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                      value={formData.TrackingNum}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                      Expiration date
                    </label>
                    <input
                      type="date"
                      name="ExpirationDate"
                      className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                      value={formData.ExpirationDate}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-2 gap-5 pt-4 border-t border-gray-50">
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                  Store Name
                </label>
                <input
                  type="text"
                  name="store_name"
                  className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                  value={formData.store_name}
                  onChange={handleInputChange}
                />
              </div>
              <div>
                <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                  Vendor Details
                </label>
                <input
                  type="text"
                  name="vendor_details"
                  className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                  value={formData.vendor_details}
                  onChange={handleInputChange}
                />
                <span className="text-[10px] text-gray-600 mt-1">(hidden)</span>
              </div>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-gray-800 mb-4">
                Product or service
              </h2>
              <div className="overflow-x-auto border border-gray-200 rounded-2xl">
                <table className="w-full text-sm">
                  <thead className="bg-gray-50 border-b">
                    <tr>
                      <th className="px-4 py-3 text-left font-semibold text-gray-600 w-12">
                        #
                      </th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-600">
                        Product
                        <span className="block text-[10px] font-normal text-blue-400">
                          auto-filled from request
                        </span>
                      </th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-600">
                        QuickBook Product/Service
                        <span className="block text-[10px] font-normal text-amber-400">
                          overrides rate &amp; description
                        </span>
                      </th>
                      <th className="px-4 py-3 text-left font-semibold text-gray-600">
                        Description
                      </th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-600 w-24">
                        Qty
                      </th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-600 w-32">
                        Rate
                      </th>
                      <th className="px-4 py-3 text-right font-semibold text-gray-600 w-32">
                        Amount
                      </th>
                      <th className="px-4 py-3 text-center font-semibold text-gray-600 w-12"></th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {formData.Line.map((line, index) => (
                      <tr
                        key={index}
                        className="hover:bg-gray-50/50 transition-colors"
                      >
                        <td className="px-4 py-3 text-gray-500">{index + 1}</td>

                        <td className="px-4 py-3">
                          <div className="capitalize">
                            <FormControl
                              className="capitalize"
                              placeholder="Select Product"
                              theme="search"
                              type="select"
                              displayValue="DisplayName"
                              options={productsDb?.map((c) => ({
                                id: c.Id || c._id,
                                DisplayName: c.productName,
                              }))}
                              value={line.db_product_id || ""}
                              onChange={(e) =>
                                handleLineChange(index, "db_product_id", e)
                              }
                            />
                          </div>
                          {line.item_name && (
                            <p className="text-[11px] text-blue-500 mt-1 truncate max-w-[160px]">
                              📦 {line.item_name}
                            </p>
                          )}
                        </td>

                        <td className="px-4 py-3">
                          <div className="capitalize">
                            <FormControl
                              className="capitalize"
                              placeholder="Select QuickBook Product"
                              theme="search"
                              type="select"
                              displayValue="DisplayName"
                              options={products?.map((c) => ({
                                id: c.Id || c._id,
                                DisplayName: c.Name,
                              }))}
                              value={
                                line.SalesItemLineDetail.ItemRef.value || ""
                              }
                              onChange={(e) =>
                                handleLineChange(index, "ItemRef", e)
                              }
                            />
                          </div>
                          {!line.SalesItemLineDetail.ItemRef.value && (
                            <p className="text-[11px] text-amber-500 mt-1">
                              ⚠ Optional: overrides rate
                            </p>
                          )}
                          {line.SalesItemLineDetail.ItemRef.value && (
                            <p className="text-[11px] text-green-500 mt-1">
                              ✓ {line.SalesItemLineDetail.ItemRef.name}
                            </p>
                          )}
                        </td>

                        <td className="px-4 py-3">
                          <input
                            type="text"
                            className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300 min-w-[150px]"
                            value={line.Description}
                            onChange={(e) =>
                              handleLineChange(
                                index,
                                "Description",
                                e.target.value,
                              )
                            }
                          />
                        </td>

                        <td className="px-4 py-3">
                          <input
                            type="number"
                            step="any"
                            onWheel={(e) => e.target.blur()}
                            min="1"
                            className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300 min-w-[65px] text-right"
                            value={line.SalesItemLineDetail.Qty}
                            onChange={(e) =>
                              handleLineChange(index, "Qty", e.target.value)
                            }
                          />
                        </td>

                        <td className="px-4 py-3">
                          <input
                            type="number"
                            step="any"
                            onWheel={(e) => e.target.blur()}
                            min="0"
                            className="h-10 w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300 min-w-[100px] text-right"
                            value={line.SalesItemLineDetail.UnitPrice || ""}
                            onChange={(e) =>
                              handleLineChange(
                                index,
                                "UnitPrice",
                                e.target.value,
                              )
                            }
                          />
                        </td>

                        <td className="px-4 py-3 text-right font-medium">
                          ${methodModel.truncateDecimal(line.Amount || 0)}
                        </td>

                        <td className="px-4 py-3 text-center">
                          <button
                            type="button"
                            onClick={() => removeLine(index)}
                            className="text-red-400 hover:text-red-600 transition-colors"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M3 6h18" />
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                            </svg>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="flex justify-end flex-wrap gap-2 mt-5">
                <button
                  type="button"
                  onClick={addLine}
                  className="px-4 py-2 text-sm font-medium text-[#115B9D] bg-[#115B9D10] border border-[#115B9D20] rounded-xl hover:bg-[#115B9D20] transition-all"
                >
                  Add product or service
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-8 lg:gap-12">
              <div className="space-y-6">
                <div>
                  <h3 className="text-sm font-semibold text-gray-700 mb-2">
                    Customer payment options
                  </h3>
                  <textarea
                    name="CustomerMemo"
                    rows="2"
                    className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                    value={formData.CustomerMemo}
                    onChange={handleInputChange}
                    placeholder="Tell your customer how you want to get paid."
                  />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-500 uppercase mb-2">
                    Memo on statement (hidden)
                  </label>
                  <textarea
                    name="PrivateNote"
                    rows="2"
                    className="w-full border rounded-xl px-3 py-2 text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                    value={formData.PrivateNote}
                    onChange={handleInputChange}
                    placeholder="This memo will not show up on your estimate, but will appear on the statement."
                  />
                </div>
              </div>

              <div className="space-y-4">
                <div className="bg-gray-50/50 rounded-2xl space-y-4 p-5">
                  {/* Subtotal */}
                  {/* <div className="flex gap-2 justify-between items-center text-sm">
                    <span className="text-gray-500 font-medium">Base Cost</span>
                    <span className="text-gray-900 font-semibold">
                      ${subtotalbeforemarkup.toFixed(2)}
                    </span>
                  </div> */}
                  {/* Markup — editable */}
                  {/*  <div className="flex gap-2 justify-between items-center text-sm">
                    <span className="text-gray-500 font-medium shrink-0">
                      Markup
                    </span>
                    <div className="flex flex-wrap justify-end items-center gap-2 ml-auto">
                      <input
                        type="number"
                        min="0"
                        onWheel={(e) => e.target.blur()}
                        name="markup_value"
                        className="w-24 p-1.5 text-right border rounded-xl text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                        value={formData.markup_value}
                        onChange={handleInputChange}
                      />
                      <div className="select_control">
                        <FormControl
                          placeholder="Select Markup Type"
                          theme="search"
                          type="select"
                          options={[
                            { name: "$", id: "fixed" },
                            { name: "%", id: "percentage" },
                          ]}
                          value={formData.markup_type}
                          onChange={(e) =>
                            setFormData({ ...formData, markup_type: e })
                          }
                        />
                      </div>
                      <span className="text-gray-900 font-semibold w-20 text-right">
                        +${markupAmt.toFixed(2)}
                      </span>
                    </div>
                  </div>*/}

                  {/* Subtotal */}
                  <div className="flex gap-2 justify-between items-center text-sm border-t border-gray-200 pt-2">
                    <span className="text-gray-500 font-medium">Subtotal</span>
                    <span className="text-gray-900 font-semibold">
                      ${methodModel.truncateDecimal(subtotal || 0)}
                    </span>
                  </div>

                  {/* Tax — now a live, editable dropdown bound to the rate's id (ported from GenerateQuote) */}
                  <div className="flex gap-2 justify-between items-center text-sm">
                    <span className="text-gray-500 font-medium shrink-0">
                      Sales tax
                    </span>
                    <div className="flex flex-wrap justify-end items-center gap-2 ml-auto">
                      <div className="min-w-[160px]">
                        <FormControl
                          placeholder="Select tax"
                          theme="search"
                          type="select"
                          displayValue="name"
                          options={allTax}
                          value={formData.tax_code_id}
                          onChange={handleTaxChange}
                        />
                      </div>
                      <span className="text-gray-900 font-semibold w-20 text-right">
                        ${methodModel.truncateDecimal(taxAmt || 0)}
                      </span>
                    </div>
                  </div>

                  {/* Discount */}
                  <div className="flex gap-2 justify-between items-center text-sm">
                    <span className="text-gray-500 font-medium shrink-0">
                      Discount
                    </span>
                    <div className="flex flex-wrap justify-end items-center gap-2 ml-auto">
                      <input
                        type="number"
                        step="any"
                        min="0"
                        name="discount_value"
                        onWheel={(e) => e.target.blur()}
                        className="w-24 p-1.5 text-right border rounded-xl text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                        value={formData.discount_value}
                        onChange={handleInputChange}
                      />
                      <div className="select_control">
                        <FormControl
                          placeholder="Select Discount Type"
                          theme="search"
                          type="select"
                          options={[
                            { name: "$", id: "fixed" },
                            { name: "%", id: "percent" },
                          ]}
                          value={formData.discount_type}
                          onChange={(e) =>
                            setFormData({ ...formData, discount_type: e })
                          }
                        />
                      </div>
                      <span className="text-gray-900 font-semibold w-16 text-right">
                        -${methodModel.truncateDecimal(discountAmt || 0)}
                      </span>
                    </div>
                  </div>

                  {/* Payment Type */}
                  <div className="flex gap-2 justify-between items-center text-sm">
                    <span className="text-gray-500 font-medium shrink-0">
                      Payment type
                    </span>
                    <div className="flex flex-wrap justify-end items-center gap-2 ml-auto">
                      <div className="select_control w-[160px]">
                        <FormControl
                          placeholder="Select Payment Type"
                          theme="search"
                          type="select"
                          options={[
                            { name: "Full Payment", id: "full" },
                            { name: "Partial Payment", id: "partial" },
                          ]}
                          value={formData.estimateType || "full"}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              estimateType: e,
                              partialValue: e === "full" ? 0 : formData.partialValue,
                            })
                          }
                        />
                      </div>
                      <span className="text-gray-900 font-semibold w-16 text-right"></span>
                    </div>
                  </div>

                  {/* Partial Payment Settings */}
                  {formData.estimateType === "partial" && (
                    <div className="flex gap-2 justify-between items-center text-sm animate-in fade-in duration-200">
                      <span className="text-gray-500 font-medium shrink-0">
                        Partial payment
                      </span>
                      <div className="flex flex-wrap justify-end items-center gap-2 ml-auto">
                        <input
                          type="number"
                          min="0"
                          step="any"
                          onWheel={(e) => e.target.blur()}
                          onFocus={() => {
                            if (formData.partialValue === 0) {
                              handleInputChange({
                                target: {
                                  name: "partialValue",
                                  value: "",
                                },
                              });
                            }
                          }}
                          name="partialValue"
                          className="w-24 p-1.5 text-right border rounded-xl text-sm text-gray-800 outline-none focus:ring-2 focus:ring-[#115B9D]/30 focus:border-[#115B9D] transition-all border-gray-300"
                          value={formData.partialValue}
                          onChange={handleInputChange}
                        />
                        <div className="select_control">
                          <FormControl
                            placeholder="Select Mode"
                            theme="search"
                            type="select"
                            options={[
                              { name: "$", id: "fixed" },
                              { name: "%", id: "percentage" },
                            ]}
                            value={formData.partialMode}
                            onChange={(e) =>
                              setFormData({ ...formData, partialMode: e })
                            }
                          />
                        </div>
                        <span className="text-[#115B9D] font-semibold w-16 text-right">
                          ${methodModel.truncateDecimal(computedPartialAmt || 0)}
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="flex gap-2 justify-between items-center">
                    <span className="text-base font-bold text-gray-900">
                      Estimate total
                    </span>
                    <span className="text-2xl font-bold text-[#115B9D]">
                      ${methodModel.truncateDecimal(estimateTotal || 0)}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex gap-2 flex-wrap items-center justify-end border-t mt-12 pt-6">
              <button
                type="button"
                onClick={() =>
                  navigate(`/order/management?tab=estimate&subTab=Negotiate`)
                }
                className="inline-flex items-center gap-2 text-sm text-gray-600 hover:opacity-80 rounded-xl transition-colors border border-gray-200 bg-white font-medium px-5 py-2.5"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="w-fit inline-flex items-center gap-2 bg-[#115B9D] hover:opacity-80 text-white text-sm rounded-xl transition-colors font-medium px-5 py-2.5"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
}
